import { Injectable } from '@angular/core';
import { WindowService } from '../../browser/window.service';

import { DynamicTranslationService } from '../../dynamic-translation/dynamic-translation.service';

import { FlashComponent } from './flash.component';

@Injectable()
export class FlashService {
  private flashComponent: FlashComponent;
  private readonly defaultTimeout: number = 5000;
  private timeOut: number;

  constructor(
    private translation: DynamicTranslationService,
    private windowService: WindowService
  ) {}

  public registerFlash(flashComponent: FlashComponent): void {
    this.flashComponent = flashComponent;
  }

  public success(
    text: string,
    timeout: number = this.defaultTimeout,
    scrollTo?: boolean
  ): void {
    clearTimeout(this.timeOut);
    text = this.translation.translate(text);
    this.hideFlash(
      text,
      'o-flash--success',
      timeout || this.defaultTimeout,
      scrollTo
    );
  }

  public error(
    text: string,
    timeout: number = this.defaultTimeout,
    scrollTo?: boolean
  ): void {
    clearTimeout(this.timeOut);
    text = this.translation.translate(text);
    this.hideFlash(
      text,
      'o-flash--danger',
      timeout || this.defaultTimeout,
      scrollTo
    );
  }

  public info(
    text: string,
    timeout: number = this.defaultTimeout,
    scrollTo?: boolean
  ): void {
    clearTimeout(this.timeOut);
    text = this.translation.translate(text);
    this.hideFlash(
      text,
      'o-flash--info',
      timeout || this.defaultTimeout,
      scrollTo
    );
  }

  private hideFlash(
    text: string,
    type: string,
    timeout: number,
    scrollTo?: boolean
  ): void {
    this.flashComponent.show(text, type, scrollTo);
    if (timeout > 0) {
      this.timeOut = this.windowService.nativeWindow.setTimeout(() => {
        this.flashComponent.hide();
      }, timeout || this.defaultTimeout);
    }
  }
}
